<p-avatar
  [image]="image"
  [size]="size"
  [shape]="shape"
  [label]="label"
  [ariaLabel]="ariaLabel"
  [ariaLabelledBy]="ariaLabelledBy"
>
  @if (icon) {
    <osp-icon [icon]="icon" iconColor="text-primary"></osp-icon>
  }
</p-avatar>
